/**
 * Created by mykurisu on 2017/7/7.
 */
import React from 'react'

import {connect} from 'react-redux'

import {Button} from 'react-weui'

import axios from 'axios'

import '../styles/record/RecordQrcode.css'

class CustomerServiceQrcode extends React.Component {

    constructor() {
        super();
        this.handleQrcodeHide = this.handleQrcodeHide.bind(this);
        this.handleBackIndex = this.handleBackIndex.bind(this);
        this.state = {
            qrcode: ''
        }
    }

    componentDidMount() {
        const {customerservice} = this.props;
        this.context.page.showToast('二维码获取中', 'loading');
        axios.get(customerservice.api).then(res => {
            if (res.data.code === 0){
                this.setState({
                    qrcode: res.data.data.qrcode_img
                })
            }
        })
    }

    handleQrcodeHide() {
        this.props.dispatch({
            type: 'CUSTOMER_QRCODE_HIDE'
        })
    }

    handleBackIndex() {
        window.location.href = '/';
    }

    render() {
        const {customerservice} = this.props;
        return (
            <div className="record-page-qrcode">
                <div className="record-page-qrcode_img">
                    <img className="qrcode-img" src={this.state.qrcode} alt=""/>
                </div>
                <div className="record-page-qrcode_title">
                    <p>{customerservice.title}</p>
                    <p>{customerservice.des}</p>
                </div>
                <div className="record-page-qrcode_btn">
                    <Button onClick={this.handleQrcodeHide} size="normal">返回</Button>
                    <Button onClick={this.handleBackIndex} size="normal" type="default">回到首页</Button>
                </div>
            </div>
        )
    }
}

CustomerServiceQrcode.contextTypes = {
    page: React.PropTypes.object,
};

export default connect((state) => ({
    customerservice: state.customerservice,
}))(CustomerServiceQrcode)


// WEBPACK FOOTER //
// ./src/components/CustomerServiceQrcode.js